/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Detail monetized similar listings selectors
 */

import {
  selectCurrentKey,
  selectError,
  selectFetching,
  selectFetchingKey,
} from '@zcode/nr/es/shared/modules/meta/selectors'
import { compose } from 'redux'

import { selectDetail } from '../../../selectors/index'

// schema
export const selectMonetizedSimilarListingsSchema = compose(
  (detail) => detail.monetizedSimilarListings,
  selectDetail
)

// monetized similar listings
export const selectMonetizedSimilarListings = compose(
  (monetizedSimilarListings) => monetizedSimilarListings.data,
  selectMonetizedSimilarListingsSchema
)

// meta
export const selectMonetizedSimilarListingsMeta = compose(
  (monetizedSimilarListings) => monetizedSimilarListings.meta,
  selectMonetizedSimilarListingsSchema
)

export const selectMonetizedSimilarListingsCurrentKey = compose(
  selectCurrentKey,
  selectMonetizedSimilarListingsMeta
)

export const selectMonetizedSimilarListingsError = compose(
  selectError,
  selectMonetizedSimilarListingsMeta
)

export const selectMonetizedSimilarListingsFetching = compose(
  selectFetching,
  selectMonetizedSimilarListingsMeta
)

export const selectMonetizedSimilarListingsFetchingKey = compose(
  selectFetchingKey,
  selectMonetizedSimilarListingsMeta
)
